/**
 * Inquiry forms: pre-fill from the URL (the PDP passes ?product=&config=,
 * the ring finder ?size=&platform=), remember what was typed so a failed
 * submit loses nothing, and show the sent request back after success.
 */
(() => {
  const root = document.querySelector('[data-pl-inquiry]');
  if (!root) return;
  const form = root.querySelector('form');
  const key = `pl-inquiry:${location.pathname}:${root.dataset.kind}`;
  const params = new URLSearchParams(location.search);

  function fieldLabel(field) {
    const label = field.id ? root.querySelector(`label[for="${field.id}"]`) : null;
    return (label ? label.textContent : field.name).replace(/\*/g, '').trim();
  }

  /* after a successful send: show the summary, then forget it */
  const sent = root.querySelector('[data-pl-inquiry-sent]');
  if (sent) {
    const summary = sent.querySelector('[data-pl-inquiry-summary]');
    try {
      const saved = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (saved && summary && saved.lines && saved.lines.length) {
        summary.innerHTML = saved.lines
          .map(([label, value]) => `<div><dt></dt><dd></dd></div>`)
          .join('');
        summary.querySelectorAll('div').forEach((row, index) => {
          row.querySelector('dt').textContent = saved.lines[index][0];
          row.querySelector('dd').textContent = saved.lines[index][1];
        });
        summary.hidden = false;
      }
      sessionStorage.removeItem(key);
    } catch (error) {
      /* storage blocked — the confirmation still stands */
    }
    return;
  }
  if (!form) return;

  const fields = Array.from(form.querySelectorAll('input[name^="contact["], select, textarea')).filter((field) => field.type !== 'hidden');

  /* restore after a server-side error */
  try {
    const saved = JSON.parse(sessionStorage.getItem(key) || 'null');
    if (saved && saved.values && form.querySelector('.pl-inq__alert')) {
      for (const field of fields) {
        if (!(field.name in saved.values)) continue;
        if (field.type === 'checkbox') field.checked = saved.values[field.name] === 'Yes';
        else field.value = saved.values[field.name];
      }
    }
  } catch (error) {
    /* ignore */
  }

  /* pre-fill from the URL */
  function selectBy(select, value) {
    const lower = value.toLowerCase();
    const option = Array.from(select.options).find(
      (o) => (o.dataset.handle || '').toLowerCase() === lower || o.value.toLowerCase() === lower,
    );
    if (option) select.value = option.value;
  }

  for (const field of form.querySelectorAll('[data-prefill]')) {
    const param = params.get(field.dataset.prefill);
    if (!param) continue;
    /* a select, a checkbox or a product handle takes the first value of a list (?size=16x16,18x18); a configuration
       is kept whole (the bag builder joins its choices with " · ") */
    const first = param.split(',')[0].trim();
    if (field.tagName === 'SELECT') selectBy(field, first);
    else if (field.type === 'checkbox') field.checked = /^(yes|1|true)$/i.test(first);
    else if (field.dataset.prefill === 'config') field.value = param.trim();
    else if (field.dataset.prefill === 'product') {
      const config = params.get('config');
      field.value = first + (config ? ` — ${config}` : '');
      fetch(`/products/${encodeURIComponent(first)}.js`)
        .then((response) => (response.ok ? response.json() : null))
        .then((product) => {
          if (!product || !product.title) return;
          /* Same clean-up as the pl-title snippet: drop the brand prefix/suffix. */
          const title = product.title
            .replace(/^PROLAST®?\s+/i, '')
            .replace(/\s+-\s+PROLAST$/i, '')
            .trim();
          field.value = title + (config ? ` — ${config}` : '');
        })
        .catch(() => {});
    } else field.value = first;
  }

  const pageField = form.querySelector('[data-pl-page-field]');
  if (pageField) pageField.value = location.pathname + location.search;

  form.addEventListener('submit', () => {
    const values = {};
    const lines = [];
    for (const field of fields) {
      const value = field.type === 'checkbox' ? (field.checked ? 'Yes' : '') : field.value.trim();
      values[field.name] = field.type === 'checkbox' ? (field.checked ? 'Yes' : 'No') : field.value;
      if (value) lines.push([fieldLabel(field), value]);
    }
    try {
      sessionStorage.setItem(key, JSON.stringify({values, lines}));
    } catch (error) {
      /* ignore */
    }
  });
})();
